package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.TextInputStyle
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Input

enum class ConfirmTone { Neutral, Danger }

@Composable
fun ConfirmModal(
    title: String,
    body: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
    cancelLabel: String = "Cancel",
    tone: ConfirmTone = ConfirmTone.Neutral,
    confirmEnabled: Boolean = true,
    confirmMatch: String? = null,
) {
    var typed by remember(confirmMatch) { mutableStateOf("") }
    val needsTyping = !confirmMatch.isNullOrBlank()
    val effectiveEnabled = confirmEnabled && (!needsTyping || typed == confirmMatch)

    Modal(
        onDismiss = onDismiss,
        widthPx = 480,
        showClose = false,
        ariaLabel = title,
        footer = {
            Button(label = cancelLabel, variant = ButtonVariant.Ghost, onClick = onDismiss)
            Button(
                label = confirmLabel,
                variant = if (tone == ConfirmTone.Danger) ButtonVariant.Danger else ButtonVariant.Primary,
                enabled = effectiveEnabled,
                onClick = onConfirm,
            )
        },
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin(bottom = Spacing.lg)) {
            SpanText(
                text = title,
                modifier = Modifier
                    .fontSize(Typography.h2.size)
                    .fontWeight(Typography.h2.weight)
                    .color(if (tone == ConfirmTone.Danger) Palette.error else Palette.textPrimary)
                    .margin(bottom = Spacing.xs),
            )
            SpanText(
                text = body,
                modifier = Modifier
                    .fontSize(Typography.body.size)
                    .color(Palette.textSecondary),
            )
        }
        if (needsTyping) {
            Column(modifier = Modifier.fillMaxWidth().margin(bottom = Spacing.lg)) {
                SpanText(
                    text = "Type \"$confirmMatch\" to confirm",
                    modifier = Modifier
                        .fontSize(Typography.bodySmall.size)
                        .color(Palette.textSecondary)
                        .margin(bottom = Spacing.xxs),
                )
                Input(
                    type = InputType.Text,
                    attrs = TextInputStyle.toModifier()
                        .fillMaxWidth()
                        .toAttrs {
                            placeholder(confirmMatch!!)
                            value(typed)
                            onInput { typed = it.value }
                        },
                )
            }
        }
    }
}
